/**
 * The wizard's one question-shaped interruption — "Start over?" and "Stop
 * reading?". Both are destructive, so CANCEL is the primary and holds focus:
 * the dialog is easier to leave than to obey.
 */
export function Confirm(props: {
  title: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
}): React.JSX.Element {
  return (
    <div
      role="alertdialog"
      aria-label={props.title}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 70,
        display: "grid",
        placeItems: "center",
        background: "rgba(0,0,0,.72)",
        padding: 20,
      }}
    >
      <div
        style={{
          display: "grid",
          gap: 16,
          maxWidth: 420,
          padding: 22,
          borderRadius: 18,
          border: "1px solid rgba(255,255,255,.10)",
          background: "rgba(16,16,19,.98)",
        }}
      >
        <div style={{ fontSize: 15.5, fontWeight: 700, color: "var(--ql-fg)", lineHeight: 1.45 }}>{props.title}</div>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          <button
            type="button"
            onClick={props.onConfirm}
            style={{
              padding: "11px 18px",
              borderRadius: 12,
              border: "1px solid rgba(255,255,255,.14)",
              background: "rgba(255,255,255,.03)",
              color: "var(--ql-fg)",
              fontWeight: 700,
              fontSize: 13.5,
              fontFamily: "inherit",
              cursor: "pointer",
            }}
          >
            {props.confirmLabel}
          </button>
          <button
            type="button"
            autoFocus
            onClick={props.onCancel}
            style={{
              padding: "11px 18px",
              borderRadius: 12,
              border: "none",
              background: "linear-gradient(135deg,#FFD500,#FFA500)",
              color: "#000",
              fontWeight: 800,
              fontSize: 13.5,
              fontFamily: "inherit",
              cursor: "pointer",
            }}
          >
            {props.cancelLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
